import React, { useEffect, useRef, useState } from "react";

import API from "../../api";


type FetchFunc = (offset:number, limit:number) => Promise<any[]>;

export default class Fetcher {
  private fetchFunc_:FetchFunc;
  private resources_:any[];

  constructor (fetchFunc:FetchFunc) {
    this.fetchFunc_ = fetchFunc;
    this.resources_ = [];
  }

  async fetch (count:number):Promise<any[]> {
    if (count <= this.resources_.length)
      return this.resources_.slice(0, count);

    const newResources = await this.fetchFunc_(this.resources_.length, count - this.resources_.length);
    this.resources_ = this.resources_.concat(newResources);

    return this.resources_.slice();
  }

  getResources ():any[] {
    return this.resources_;
  }

  clear () {
    this.resources_ = [];
  }

  async refetch (idx:number, count:number) {
    idx   = Math.max(idx, 0);
    count = Math.min(count, this.resources_.length);

    if (count <= 0)
      return;

    const newResources = await this.fetchFunc_(idx, count);
    for (let i=0; i<newResources.length; ++i)
      this.resources_[i+idx] = newResources[i];
  }
};
